class SoundManager {
    constructor() {
        this.ctx = new (window.AudioContext || window.webkitAudioContext)();
        this.muted = localStorage.getItem('geoceuta_muted') === 'true';
    }

    setMuted(value) {
        this.muted = value;
        localStorage.setItem('geoceuta_muted', value);
    }

    playTone(freq, type, duration, startTime = 0) {
        if (this.muted) return;

        if (this.ctx.state === 'suspended') {
            this.ctx.resume();
        }
        const osc = this.ctx.createOscillator();
        const gain = this.ctx.createGain();

        osc.type = type;
        osc.frequency.value = freq;

        osc.connect(gain);
        gain.connect(this.ctx.destination);

        osc.start(this.ctx.currentTime + startTime);

        // Envelope
        gain.gain.setValueAtTime(0.1, this.ctx.currentTime + startTime);
        gain.gain.exponentialRampToValueAtTime(0.001, this.ctx.currentTime + startTime + duration);

        osc.stop(this.ctx.currentTime + startTime + duration);
    }

    playCorrect() {
        // High pitched sequence (Ding-Ding!)
        this.playTone(600, 'sine', 0.1, 0);
        this.playTone(800, 'sine', 0.3, 0.1);
    }

    playIncorrect() {
        // Low pitched (Buzz)
        this.playTone(200, 'sawtooth', 0.1, 0);
        this.playTone(150, 'sawtooth', 0.3, 0.1);
    }

    playCelebration() {
        // Victory Arpeggio
        [440, 554, 659, 880].forEach((freq, i) => {
            this.playTone(freq, 'triangle', 0.2, i * 0.1);
        });
    }

    playPop() {
        this.playTone(600, 'sine', 0.1);
    }

    playAction() {
        this.playTone(400, 'sine', 0.05);
    }

    playUndo() {
        this.playTone(300, 'sine', 0.15);
    }
}

export const sounds = new SoundManager();
